import React from 'react'
import PanelHead from '../../../UI/Panel/PanelHead'
import PanelBody from '../../../UI/Panel/PanelBody'
import AddEmployeeForm from '../../../UI/Employees/Add'

const AddEmployee = () => {
  return (
    <div>
      <PanelHead title="Add Employee" />
      <PanelBody content={<AddEmployeeForm />} />
    </div>
  )
}

export default React.memo(AddEmployee);